import { ASNDocumentType } from '../../lib/api';

export interface ASNFormData {
  asn_number: string;
  schedules: number[];
  courier: string;
  tracking_number: string;
  method_of_transport: string;
  weight_kg: string;
  distance_km: string;
  expected_delivery_date: string;
  notes: string;
}

export interface ASNScheduleDetail {
  id: number;
  po_number?: string;
  po_id?: number;
  po_line_id?: number;
  line_number?: number;
  part_number?: string;
  description?: string;
  schedule_qty?: string | number;
  quantity?: number;
  shipped_qty?: string | number;
  balance_qty?: string;
  unit_of_measure?: string;
  status?: string;
  schedule_date?: string;
  due_date?: string;
  supplier_name?: string;
  customer_name?: string;
  grn_number?: string;
  created_at?: string;
  updated_at?: string;
  shipment_number?: string;
  tracking_number?: string;
  po_line_details?: {
    po_details?: { po_number: string };
    line_number?: number;
    part_number?: string;
    description?: string;
    unit_of_measure?: string;
  };
}

export interface ASNData {
  id: number;
  asn_number: string;
  status: string;
  courier?: string;
  tracking_number?: string;
  invoice_number?: string;
  method_of_transport?: string;
  expected_delivery_date?: string;
  actual_delivery_date?: string;
  weight_kg?: string | number;
  distance_km?: string | number;
  carbon_emission_kg?: string | number;
  calculated_carbon_emission?: string | number;
  notes?: string;
  supplier_details?: { name: string };
  customer_details?: { name: string };
  schedules_details?: ASNScheduleDetail[];
  source_type?: string;
  call_off?: number | null;
  call_off_reference?: string;
  delivery_lines_details?: ASNDeliveryLineDetail[];
}

export interface ASNDeliveryLineDetail {
  id: number;
  delivery_number: string;
  part_number: string;
  part_description: string;
  qty_released: string;
  delivery_option: string;
  delivery_address: string;
  sales_order: string;
  po_order_number: string;
  po_line_number: string;
  call_off_reference: string;
}

export interface ASNModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: ASNFormData | Record<string, string | number | boolean>) => Promise<void>;
  /**
   * When set, the wizard opens on the delivery-lines source and auto-selects
   * every available delivery line whose call-off matches this ID. Used when
   * the supplier launches Create ASN from a specific call-off.
   */
  initialCallOffId?: number;
}

export interface ASNDetailModalProps extends ASNModalProps {
  asn: ASNData;
}

// Document type labels for display
export const DOCUMENT_TYPE_LABELS: Record<ASNDocumentType, string> = {
  cofc: 'Certificate of Conformance',
  fair: 'First Article Inspection Report',
  delivery_note: 'Delivery Note',
  material_cert: 'Material Certificate',
  commercial_invoice: 'Commercial Invoice',
  packing_list: 'Packing List',
  other: 'Other',
};
